// src/components/TalentPool.js
import React, { useState } from 'react';
import Navbar from '../NavBar/navbar';
import FilterOptions from '../filterOptions/filterOptions';
import CandidateTable from '../CandidateTable/CandidateTable';
import SearchBar from '../Search Bar/SearchBar';
import { candidates as initialCandidates } from '../data/candidateData';
import './TalentPool.css';

const TalentPool = () => {
  const [candidates, setCandidates] = useState(initialCandidates);
  const [filters, setFilters] = useState({});
  const [selectedFields, setSelectedFields] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');

  const filterFields = ['name', 'email', 'phone', 'title', 'source'];

  const handleFilterChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;
    setSelectedFields((prevSelected) =>
      checked ? [...prevSelected, value] : prevSelected.filter((field) => field !== value)
    );
  };

  // Combine search query and filter criteria to filter candidates
  const applyFilters = (candidates) => {
    return candidates.filter((candidate) => {
      // Apply filters
      const isFiltered = Object.keys(filters).every((key) =>
        candidate[key]?.toLowerCase().includes(filters[key].toLowerCase())
      );

      // Apply search query
      const isSearched = Object.values(candidate).some((value) =>
        value && value.toString().toLowerCase().includes(searchQuery.toLowerCase())
      );

      return isFiltered && isSearched;
    });
  };

  const filteredCandidates = applyFilters(candidates);

  return (
    <div className="container-fluid talent-pool">
      <Navbar />
      

      <div className="filter-and-table">
        <FilterOptions
          filters={filters}
          handleFilterChange={handleFilterChange}
          filterFields={filterFields}
          handleCheckboxChange={handleCheckboxChange}
          selectedFields={selectedFields}
        />
        <SearchBar searchQuery={searchQuery} setSearchQuery={setSearchQuery} />
        <CandidateTable candidates={filteredCandidates} />
      </div>
    </div>
  );
};

export default TalentPool;
